import React from 'react';
import { Box, Button, CircularProgress, Tooltip, Typography } from '@mui/material';
import SyncIcon from '@mui/icons-material/Sync';
import { timeAgo, isStale } from '../../utils/relativeTime';

/**
 * A cycle-wide "Jira synced X ago" caption with an optional Refresh button.
 *
 * The time is the oldest successful sync across the cycle's Jira-linked bets, so
 * the phrase honestly means every scope is at least that fresh. It turns to a
 * warning colour when a bet is failing or the whole cycle is stale, matching how
 * a single BetCard reports its own freshness.
 *
 * Presentational only: the caller owns the syncing state and the refresh call.
 */
const JiraSyncStatus = ({ lastSyncedAt, failing, syncing, canRefresh, onRefresh }) => {
  const warn = failing || isStale(lastSyncedAt);
  const ago = timeAgo(lastSyncedAt) || 'never';

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
      <Typography
        variant="caption"
        color={warn ? 'warning.main' : 'text.secondary'}
        sx={{ whiteSpace: 'nowrap' }}
      >
        Jira synced {ago}
      </Typography>
      {canRefresh && (
        <Tooltip title="Pull the latest scopes from Jira for every bet in this cycle.">
          <span>
            <Button
              size="small"
              startIcon={syncing ? <CircularProgress size={14} /> : <SyncIcon />}
              onClick={onRefresh}
              disabled={syncing}
            >
              Refresh
            </Button>
          </span>
        </Tooltip>
      )}
    </Box>
  );
};

export default JiraSyncStatus;
